var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Hammer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7.6289062 3.0429688 L 6.2148438 4.4570312 L 10.84375 9.0859375 L 2.84375 17.085938 C 1.727938 18.201749 1.727938 20.040438 2.84375 21.15625 L 3.1367188 21.449219 L 3.5507812 21.449219 L 3.5273438 21.439453 C 3.5347932 21.443188 3.5434362 21.443225 3.5507812 21.447266 L 3.5507812 21.449219 L 3.5546875 21.449219 C 4.647821 22.048375 5.9931689 22.077144 6.9140625 21.15625 L 14.914062 13.15625 L 18.585938 16.828125 L 19.292969 16.121094 L 22.824219 12.589844 L 19.128906 8.8574219 L 20.414062 7.5703125 L 16.429688 3.5859375 L 15.164062 4.8496094 L 13.375 3.0429688 L 7.6289062 3.0429688 z M 9.6289062 5.0429688 L 12.539062 5.0429688 L 20.003906 12.582031 L 18.585938 14 L 9.6289062 5.0429688 z M 12.257812 10.5 L 13.5 11.742188 L 5.5 19.742188 C 5.147812 20.094376 4.6100005 20.094376 4.2578125 19.742188 C 3.9056245 19.389999 3.9056245 18.852188 4.2578125 18.5 L 12.257812 10.5 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Hammer);
export default __webpack_public_path__ + "static/media/icons8-hammer.f8569e1f.svg";
export { ForwardRef as ReactComponent };